import React, { FC } from "react"
import { FetchedCourse } from "./BookingPricePreview"
import { Currency, GenerateScheduledPaymentsByCourseMutation, InstallmentRate } from "../../../../generated/graphql"
import moment from "moment"
import css from "./MonthlyPaymentList.module.css"
import { useCurrency } from "../../../../helpers/currencyHelper"
import { renderAmount } from "../../../../helpers/renderAmount"

type InstallmentRates = FetchedCourse["installmentRates"]
export type PartInstallmentRate = Pick<InstallmentRate, "id" | "installmentAmount" | "installmentDue">

type MonthlyPaymentListProps = {
    installmentPlan: InstallmentRates
    discountInEuro: number | null
    discountInPercentage: number | null
    course: FetchedCourse
    attendeeId?: string
    preview?: GenerateScheduledPaymentsByCourseMutation["generateScheduledPaymentsByCourse"]
}

const MonthlyPaymentList: FC<MonthlyPaymentListProps> = ({
    installmentPlan,
    discountInEuro,
    discountInPercentage,
    course,
    attendeeId,
    preview,
}) => {
    const previewRates: Array<PartInstallmentRate & { label?: string | null; isAdditionalItem?: boolean }> | undefined = preview?.scheduledPayments.map((rate) => {
        return {
            id: rate.id,
            installmentAmount: rate.paymentAmount,
            installmentDue: rate.paymentDue,
            // Zusatzposten-Zeilen tragen ihren Titel statt des Monatslabels
            label: rate.additionalItemId ? rate.title : undefined,
            isAdditionalItem: Boolean(rate.additionalItemId),
        }
    })

    if (previewRates) {
        return (
            <>
                {previewRates.map((rate, index) => {
                    if (!rate) return null

                    return (
                        <div key={rate.id}>
                            <RenderMonthlyPaymentEntry rate={rate} index={index} label={rate.label} isAdditionalItem={rate.isAdditionalItem} />
                        </div>
                    )
                })}
            </>
        )
    }

    return (
        <>
            {installmentPlan?.map((rate, index) => {
                if (!rate) return null

                return (
                    <div key={rate.id}>
                        <RenderMonthlyPaymentEntry rate={rate} index={index} />
                    </div>
                )
            })}
        </>
    )
}

export default MonthlyPaymentList

export const RenderMonthlyPaymentEntry = ({ rate, index, label, isAdditionalItem }: { rate?: PartInstallmentRate; index: number; label?: string | null; isAdditionalItem?: boolean }) => {
    const currency = useCurrency()
    if (!rate) return null

    return (
        <div key={rate.id} className={css.monthlyPaymentEntry}>
            <div className={css.main}>
                <div className={css.month}>
                    <span className={css.num}>{`${index + 1}.`}</span>
                    <span>{label ?? moment(rate.installmentDue).format("MMM YY")}</span>
                </div>
                <div className={css.amount}>
                    {/* Zusatzposten sind Aufschläge auf den Kurspreis — wie in der
                        Posten-Auswahl unten mit „+" gekennzeichnet */}
                    {isAdditionalItem ? "+ " : ""}
                    {renderAmount({
                        amount: rate.installmentAmount ?? 0,
                        currency: currency.short as Currency,
                    })}
                </div>
            </div>
            <div className={css.sub}>{`Zahlbar bis ${moment(rate.installmentDue).format("DD.MM.YY")}`}</div>
        </div>
    )
}
